module.exports = __webpack_public_path__ + "img/IMG_5899.6bc69660.jpg";